export var IdSoundState;
(function (IdSoundState) {
    IdSoundState["Enabled"] = "Enabled";
    IdSoundState["Disabled"] = "Disabled";
})(IdSoundState || (IdSoundState = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdSoundState.ts
// module id = 434
// module chunks = 3